import { useState } from "react";
import { Alert } from "antd";

export interface PublicSiteBanner {
  id: string;
  title: string;
  message: string;
  type: "info" | "success" | "warning" | "error";
}

const SiteBannerStrip = ({ banners }: { banners: PublicSiteBanner[] }) => {
  const [dismissed, setDismissed] = useState<string[]>([]);
  const visible = banners.filter((banner) => !dismissed.includes(banner.id)).slice(0, 3);
  if (visible.length === 0) return null;

  return <div style={{ display: "grid", gap: 8, marginBottom: 16 }}>
    {visible.map((banner) => <Alert
      key={banner.id}
      type={banner.type}
      message={banner.title}
      description={banner.message}
      banner
      showIcon
      closable
      onClose={() => setDismissed((previous) => [...previous, banner.id])}
    />)}
  </div>;
};

export default SiteBannerStrip;
